import { useLocation } from 'react-router-dom';
import { ProductSelectionMode, type ProductSelectionContext } from './components';
import ProductViewPage from './view/ProductViewPage';
import ProductSingleSelectPage from './single-select/ProductSingleSelectPage';
import ProductMultiSelectPage from './multi-select/ProductMultiSelectPage';

export default function ProductPage() {
  const location = useLocation();
  const selectionContext = getSelectionContext(location.state);

  switch (selectionContext.mode) {
    case ProductSelectionMode.SINGLE_PRODUCT_SELECTION:
      return <ProductSingleSelectPage />;
    case ProductSelectionMode.MULTIPLE_PRODUCT_SELECTION:
      return <ProductMultiSelectPage />;
    case ProductSelectionMode.PRODUCT_VIEW:
    default:
      return <ProductViewPage />;
  }
}

function getSelectionContext(state: unknown): ProductSelectionContext {
  const context = state as ProductSelectionContext;
  if (context?.mode) {
    return context;
  }

  return {
    mode: ProductSelectionMode.PRODUCT_VIEW,
  };
}
